import React, { useState } from "react"
import { Card } from "reactstrap"
import styles from "./Court.module.scss"
import CourtModal from "./CourtModal"
import { UnPause } from "../"
import { getSportsConfig } from "../../utility/constants/sportConfig"
import { gridColumns, gridRows } from "../../utility/constants/gridSize"

const Court = ({ noStart = false }) => {
	const [coordinates, setCoordinates] = useState(false)
	const positions = getPositions()
	const spectate = localStorage.getItem("spectate")

	const createGridRow = (y) => {
		const columns = []
		for (let x = 0; x < gridColumns; x++) {
			columns.push(
				<button
					key={`btn-${x}-${y}`}
					onClick={() => setCoordinates({ x, y })}
				></button>
			)
		}
		return columns
	}

	const createGrid = () => {
		const rows = []
		for (let y = 0; y < gridRows; y++) {
			rows.push(createGridRow(y))
		}

		if (spectate) {
			addPlayers(rows, JSON.parse(localStorage.getItem("homeTeam")).players)
			addPlayers(
				rows,
				JSON.parse(localStorage.getItem("awayTeam")).players,
				true
			)
		}

		return (
			<div className={styles.grid}>
				{rows.map((row, index) => (
					<div
						key={`row-${index}`}
						className={`${styles.gridRow} ${
							spectate ? "" : styles.withHover
						} `}
					>
						{row}
					</div>
				))}
			</div>
		)
	}

	const homeTeam = JSON.parse(localStorage.getItem("homeTeam"))
	const awayTeam = JSON.parse(localStorage.getItem("awayTeam"))

/* 	console.log("Home team", homeTeam)
	console.log("Away team", awayTeam) */

	const addPlayers = (rows, players, isAwayTeam) => {
		players.forEach((player) => {
			if (
				player.position &&
				player.position.toLowerCase() !== "bench" &&
				player.position.toLowerCase() !== "bench-gk" &&
				player.position.toLowerCase() !== "nedostaje"
			) {
				const { x, y } = positions[player.position] ?? {}
				if (x != undefined) {
					if (!isAwayTeam) addPlayer(rows, player.tshirtNumber, x, y)
					else
						addPlayer(
							rows,
							player.tshirtNumber,
							gridColumns - x - 1,
							gridRows - y - 1,
							true
						)
				}
			}
		})
	}

	const addPlayer = (rows, tshirtNumber, x, y, isAwayTeam) => {
		rows[y][x] = (
			<button key={`btn-${x}-${y}`} onClick={() => setCoordinates({ x, y })}>
				<span>
					<i
						style={
							isAwayTeam
								? {
										fontSize: "50px",
										color: `${
											awayTeam.jerseyColor?.jersey
												? awayTeam.jerseyColor?.jersey
												: "red"
										}`,
								  }
								: {
										fontSize: "50px",
										color: `${
											homeTeam.jerseyColor?.jersey
												? homeTeam.jerseyColor?.jersey
												: "blue"
										}`,
								  }
						}
						className="fas fa-tshirt"
					>
						<span
							style={{
								fontSize: "large",
								position: "absolute",
								top: "50%",
								right: "50%",
								transform: "translate(50%, -50%)",
								color: `${
									isAwayTeam
										? awayTeam.jerseyColor?.number
											? awayTeam.jerseyColor?.number
											: "white"
										: homeTeam.jerseyColor?.number
										? homeTeam.jerseyColor?.number
										: "white"
								}`,
							}}
						>
							{tshirtNumber}
						</span>
					</i>
				</span>
			</button>
		)
	}

	return (
		<Card className={styles.courtWrapper}>
			<div
				className={`
					${styles.courtRatio}
					${styles[localStorage.getItem("sport").toLowerCase()]}
				 `}
			>
				{createGrid()}
			</div>
			{!spectate && (
				<CourtModal
					hideModal={() => setCoordinates({})}
					coordinates={coordinates}
				/>
			)}
			{/* The following line blocks the court from being used, this way the user clearly sees its paused, this was later removed because the clients wanted to add events */}
			{/* {!spectate && !noStart && <UnPause />} */}
		</Card>
	)
}

export default Court

// ? This was a quick and easy way to put all formations in one
const getPositions = () => {
	const allPositions = [].concat(
		...Object.values(
			getSportsConfig(localStorage.getItem("sport"))?.formations ?? []
		)
	)
	const positions = {}
	allPositions.forEach((position) => {
		if (!positions[position.name]) positions[position.name] = position.coordinate
	})
	return positions
}
